/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORTS : DETAIL CTAs : STYLES --------------- ++++++++++ */
export default theme => ({
    detailCTAs: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: replacePXinStringWithEM(`0px ${theme.spacing.sides}`),
        '& .ctas': {
            '& .button':{
                marginRight: pxToEm(10),
                marginBottom: pxToEm(10),
                maxWidth: pxToEm(149),
                maxHeight: pxToEm(48),
                fontSize: pxToEm(16)
            }
        }
    },
    [mediaQuery.thinnest]: {
        previewCTAs: {
            flexDirection: 'column',
            alignItems: 'center',
            '& .ctas': {
                '& .button':{
                    width: '100%'
                }
            }
        }
    }
});
